import React from 'react';
import { motion } from 'framer-motion';
import { PlusCircleIcon, UsersIcon, HandshakeIcon } from 'lucide-react';
import { WEB_JOIN_URL } from '../data/launch';
const steps = [{
  icon: PlusCircleIcon,
  title: 'Create a kitty',
  detail: 'Name it, pick the currency, and you are ready.'
}, {
  icon: UsersIcon,
  title: 'Invite your group',
  detail: 'Share a link, a QR code or a join code.'
}, {
  icon: HandshakeIcon,
  title: 'Settle up',
  detail: 'Everyone sees who owes whom, then pays directly.'
}];
export function HowItWorksStrip() {
  return <section id="how-it-works" aria-labelledby="how-it-works-heading" className="border-y border-gray-100 bg-white py-14 lg:py-16" data-id="element-189" data-mp="35e3i1i4pdlpq">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-190" data-mp="3ad6l4x14hhv2">
        <h2 id="how-it-works-heading" className="sr-only" data-id="element-191" data-mp="13m7461v2bzrs">
          How KittyPot works
        </h2>

        <motion.ol initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.06
          }
        }
      }} className="grid gap-8 sm:grid-cols-3 sm:gap-6 lg:gap-10" data-id="element-192" data-mp="18ltjcgugbq38">
          {steps.map((step, index) => <motion.li key={step.title} variants={{
          hidden: {
            opacity: 0,
            y: 14
          },
          visible: {
            opacity: 1,
            y: 0,
            transition: {
              duration: 0.35,
              ease: [0.22, 1, 0.36, 1]
            }
          }
        }} className="relative flex gap-4 sm:block" data-id="element-193" data-mp="3dhbiyuxfl5qg" data-mpi={index}>
              <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-2xl bg-kitty-yellow sm:mb-4" data-id="element-194" data-mp="2tt2f3nmizbb4">
                <step.icon className="h-6 w-6 text-kitty-dark" aria-hidden="true" data-id="element-195" data-mp="e155f6bh984k" />
              </span>
              <div data-id="element-196" data-mp="94xwr5rp5iix">
                <h3 className="text-xl font-extrabold text-kitty-dark" data-id="element-197" data-mp="32uth92rzctyn">
                  <span className="text-kitty-dark/30" data-id="element-198" data-mp="32wxmpp5j2111">{index + 1}. </span>
                  {step.title}
                </h3>
                <p className="mt-1 text-base leading-relaxed text-gray-600" data-id="element-199" data-mp="3bvrdv0039z77">
                  {step.detail}
                </p>
              </div>
            </motion.li>)}
        </motion.ol>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4
      }} className="mt-10 flex flex-col items-start gap-3 rounded-2xl bg-[#FFFBF2] p-5 text-base text-gray-700 sm:flex-row sm:items-center sm:gap-4" data-id="element-200" data-mp="2k4ln3a69ddul">
          <span className="inline-flex flex-shrink-0 items-center rounded-full bg-kitty-yellow px-3.5 py-1.5 text-sm font-black uppercase tracking-wide text-kitty-dark" data-id="element-201" data-mp="2xx1ippwty9lh">
            No app required
          </span>
          <span data-id="element-202" data-mp="25d2xcknlk4y1">
            Invite friends by link, QR or code. They can join from their browser
            without downloading the app.{' '}
            <a href={WEB_JOIN_URL} target="_blank" rel="noopener noreferrer" className="font-bold text-kitty-dark underline decoration-2 underline-offset-4 transition-colors duration-150 hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-kitty-dark rounded" data-id="element-203" data-mp="1swk21lqwucpw">
              Been invited? Join here
            </a>
            .
          </span>
        </motion.p>
      </div>
    </section>;
}